'use client';

import { Link, useUi } from '@weareconceptstudio/core';
import { config } from '@/helpers';
import { HEADER_COLLAPSIBLE_MAX_WIDTH } from '@/constants';
import LogoStyle from './style';

const Logo = ({ className, useMobileLogo = false }) => {
	const { winWidth } = useUi();
	const effectiveWidth = typeof window !== 'undefined' ? window.innerWidth : null;
	if (!effectiveWidth) return;
	const isMobileLogo = useMobileLogo && effectiveWidth <= 768;

	return (
		<LogoStyle className={`${className || ''}`}>
			<Link
				ariaLabel='link Home'
				url={config.routes.home.path}>
				{isMobileLogo ? (
					<svg
						viewBox='0 0 23 38'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<g id='Group 28887'>
							<g id='Group 8'>
								<g id='Clip path group'>
									<mask
										id='mask0_140_7263'
										maskUnits='userSpaceOnUse'
										x='0'
										y='8'
										width='23'
										height='22'>
										<g id='clip-path-2'>
											<path
												id='Path 27'
												fillRule='evenodd'
												clipRule='evenodd'
												d='M11.4865 8.01502C13.7175 8.01273 15.8991 8.6434 17.7555 9.82727C19.6118 11.0111 21.0596 12.6951 21.9155 14.666C22.7715 16.637 22.9971 18.8066 22.5641 20.9003C22.1312 22.9941 21.0589 24.9179 19.483 26.4287C17.907 27.9394 15.8981 28.9691 13.7104 29.3876C11.5226 29.8061 9.2544 29.5946 7.19234 28.7798C5.13028 27.965 3.3671 26.5836 2.12577 24.8101C0.884437 23.0367 0.220691 20.9509 0.218511 18.8166C0.215588 15.9548 1.40104 13.2091 3.51416 11.1835C5.62728 9.15782 8.49498 8.01809 11.4865 8.01502Z'
												fill='white'
											/>
										</g>
									</mask>
									<g mask='url(#mask0_140_7263)'>
										<g id='Group 7'>
											<path
												id='Rectangle 8'
												d='M0.920662 6.34019L-1.53711 28.9266L22.0729 31.2779L24.5307 8.69141L0.920662 6.34019Z'
												fill='url(#paint0_linear_140_7263)'
											/>
										</g>
									</g>
								</g>
							</g>
							<path
								id='Rectangle 9'
								d='M22.9622 0H0V4.24223H22.9622V0Z'
								fill='white'
							/>
							<path
								id='Rectangle 10'
								d='M22.9954 33.7356L0.0332031 33.7578L0.0376921 38L22.9999 37.9778L22.9954 33.7356Z'
								fill='white'
							/>
						</g>
						<defs>
							<linearGradient
								id='paint0_linear_140_7263'
								x1='3.85014'
								y1='25.696'
								x2='19.3948'
								y2='10.7553'
								gradientUnits='userSpaceOnUse'>
								<stop stopColor='#A700DE' />
								<stop
									offset='1'
									stopColor='#FE0085'
								/>
							</linearGradient>
						</defs>
					</svg>
				) : (
					<svg
						viewBox='0 0 307 48'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'>
						<mask
							id='mask0_102_3852'
							maskUnits='userSpaceOnUse'
							x='0'
							y='0'
							width='307'
							height='48'>
							<path
								d='M307 0H0V48H307V0Z'
								fill='white'
							/>
						</mask>
						<g mask='url(#mask0_102_3852)'>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M299.586 25.1003L299.597 36.667H294.573L294.563 25.1003L287.101 13.5977L291.516 10.9963L297.075 19.5563L302.578 11.023L307.056 13.5563L299.586 25.1003Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M276.194 17.0655L276.211 36.6948H271.187L271.169 17.0655L264.963 17.0721V11.6761L282.402 11.6575V17.0535L276.194 17.0655Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M250.223 31.5389L250.21 17.0909H247.207V11.6949L258.227 11.6829V17.0789H255.221L255.234 31.5269H258.242V36.9082L247.222 36.9202V31.5389H250.223Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M233.132 17.1113H228.728L227.03 18.87L227.04 29.8206L228.73 31.554H233.149L237.215 27.3526L240.85 31.1246L235.161 36.9326L226.755 36.942L222.017 32.1126L222.002 16.59L226.728 11.7166L235.134 11.7073L240.826 17.538L237.201 21.3206L233.132 17.1113Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M170.133 31.6268L170.121 17.1788H167.118V11.7827L178.138 11.7708V17.1667H175.131L175.145 31.6147H178.151V36.9961L167.132 37.0081V31.6268H170.133Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M153.164 25.4813L149.258 33.6306L145.338 25.4906L145.348 36.9026H140.325L140.302 11.8973H144.452L149.247 21.8586L154.024 11.8879H158.175L158.198 36.8933H153.174L153.164 25.4813Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M134.804 27.1014L127.494 12.052H124.219L116.936 27.1187L116.944 36.8667H121.973L121.965 30.4667L129.787 30.4574L129.795 36.8573L134.817 36.848L134.804 27.1014ZM123.585 25.076L125.864 20.3627L128.152 25.0667L123.585 25.076Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M98.5726 27.503L98.5813 36.8884H93.5584L93.5352 12.0791H98.5593L98.5679 21.4724L108.728 10.967L112.373 14.7004L102.88 24.4804L112.393 34.2257L108.755 37.971L98.5726 27.503Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M88.0407 27.1427L80.7312 12.092L77.442 12.1014L70.1665 27.16L70.1751 36.9174L75.1955 36.908L75.187 30.508L83.018 30.4987L83.0264 36.8987H88.0468L88.0407 27.1427ZM76.8122 25.1173L79.1 20.4134L81.3879 25.1173H76.8122Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M65.6249 34.2836L58.7528 27.2169H59.9223L64.6491 22.3663L64.6405 16.7662L59.9051 11.9062L46.7676 11.9156L46.7932 36.9436L51.8147 36.9342L51.8063 27.5542L61.9836 38.0209L65.6249 34.2836ZM51.7976 21.8383V17.3049L57.9121 17.2956L59.6177 19.0529V20.0569L57.9182 21.8249L51.7976 21.8383Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M28.4242 30.0398L30.1127 31.7732H34.5483L36.2539 30.0265L36.2368 12.1438H41.2609L41.2792 32.3198L36.55 37.1598L28.144 37.1691L23.4062 32.3398L23.3867 12.1638H28.4108L28.4242 30.0398Z'
								fill='white'
							/>
							<path
								fillRule='evenodd'
								clipRule='evenodd'
								d='M12.8623 25.6346L8.95667 33.7839L5.0363 25.6439L5.04612 37.0559H0.0231992L0 12.0506H4.15057L8.94566 22.0119L13.7225 12.0413H17.873L17.895 37.0466H12.8721L12.8623 25.6346Z'
								fill='white'
							/>
							<mask
								id='mask1_102_3852'
								maskUnits='userSpaceOnUse'
								x='188'
								y='11'
								width='26'
								height='26'>
								<path
									fillRule='evenodd'
									clipRule='evenodd'
									d='M201.142 11.9983C203.61 11.9957 206.023 12.7186 208.076 14.0756C210.129 15.4326 211.731 17.3627 212.677 19.622C213.624 21.8812 213.874 24.368 213.395 26.7679C212.916 29.1679 211.73 31.3731 209.987 33.1048C208.244 34.8364 206.022 36.0167 203.602 36.4964C201.182 36.9761 198.674 36.7337 196.393 35.7997C194.112 34.8658 192.162 33.2823 190.789 31.2495C189.416 29.2167 188.682 26.8259 188.68 24.3795C188.676 21.0992 189.988 17.952 192.325 15.6301C194.662 13.3082 197.834 12.0018 201.142 11.9983Z'
									fill='white'
								/>
							</mask>
							<g mask='url(#mask1_102_3852)'>
								<path
									d='M189.456 10.0744L186.738 35.9639L212.851 38.6589L215.57 12.7694L189.456 10.0744Z'
									fill='url(#paint0_linear_102_3852)'
								/>
							</g>
							<path
								d='M213.833 2.97095H188.436V8.33895H213.833V2.97095Z'
								fill='white'
							/>
							<path
								d='M213.87 40.8588L188.473 40.887L188.478 46.255L213.875 46.2268L213.87 40.8588Z'
								fill='white'
							/>
						</g>
						<defs>
							<linearGradient
								id='paint0_linear_102_3852'
								x1='192.696'
								y1='32.2608'
								x2='210.478'
								y2='15.7697'
								gradientUnits='userSpaceOnUse'>
								<stop stopColor='#A700DE' />
								<stop
									offset='1'
									stopColor='#FE0085'
								/>
							</linearGradient>
						</defs>
					</svg>
				)}
			</Link>
		</LogoStyle>
	);
};

export default Logo;
